<h2>Våra senaste inlägg</h2>

<div class="blog-list">
  <div class="blog-list-item" *ngFor="let blog of blogs" [style.background-image]="'url(' + (blog.imgUrl || '' | cdn) + ')'" (click)="goToBlog(blog)">
    <div class="blog-info">
      <h3 [innerHtml]="blog.name"></h3>
    </div>
  </div>
</div>